import React from 'react';
import { Leaf, Award, ShieldCheck, Heart } from 'lucide-react';
import { useTranslation } from "react-i18next";
import Section from './ui/Section';

const TrustStrip = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: <Leaf className="w-6 h-6" />,
      title: t("trust.natural.title"),
      desc: t("trust.natural.desc")
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: t("trust.quality.title"),
      desc: t("trust.quality.desc")
    },
    {
      icon: <ShieldCheck className="w-6 h-6" />,
      title: t("trust.safe.title"),
      desc: t("trust.safe.desc")
    },
    {
      icon: <Heart className="w-6 h-6" />,
      title: t("trust.customer.title"),
      desc: t("trust.customer.desc")
    },
  ];

  return (
    <div className="bg-fecos-bg border-y border-fecos-border/50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {features.map((item, i) => (
            <Section key={i} delay={i} className="flex flex-col items-center text-center space-y-3 group cursor-default">
              <div className="w-12 h-12 rounded-2xl bg-fecos-surface flex items-center justify-center text-fecos-text/60 group-hover:bg-fecos-accent group-hover:text-white transition-all duration-500 ease-out shadow-sm group-hover:scale-110">
                {item.icon}
              </div>
              <div>
                <h4 className="font-semibold text-fecos-text text-sm mb-1">{item.title}</h4>
                <p className="text-xs text-fecos-gray">{item.desc}</p>
              </div>
            </Section>
          ))}

        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
